import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImage404Svg';

export const ResponsesImage404 = createResponsesImage({
  name: 'ResponsesImage404',
  component,
});
